import React from 'react';
import styled from 'styled-components';
import { isOpenfin } from '../openfin/OpenfinAdapter';

const RouteWrapper: React.FunctionComponent<{}> = ({ children }) => {
  return (
    <Container inOpenfinMode={isOpenfin}>
      {children}
    </Container>
  );
};

const Container = styled.div<{ inOpenfinMode: boolean}>`
  height: ${({ inOpenfinMode }) => {
    return inOpenfinMode ? '100vh' : '100%';
  }};
  background-color: ${({ theme }) => theme.core.lightBackground};
  color: ${({ theme }) => theme.core.textColor};
`;

export default RouteWrapper;
